export function extractUsername(url: string) {
  if (url) {
    const regex = /(?:https?:\/\/)?(?:www\.)?([^/?]+)\.com\/([^/?]+)/
    const match = url.match(regex)
    return match ? match[2] : null
  }
}
